import { useEffect, useLayoutEffect, useReducer } from "react";

import { v4 as uuidv4 } from "uuid";

import Helper from "../helper";

export const addARIAGroupingAttributes = form => {
	if (form && form.querySelectorAll(".flw__label").length > 0) {
		const labels = form.querySelectorAll(".flw__label:not(.flw__radio-group__radio__label)");
		labels.forEach(item => {
			const labelWrapper = item.parentElement.parentElement;
			const label = labelWrapper.querySelector(".flw__label");
			const groupWrapper = labelWrapper.children[0];

			if (
				(labelWrapper.querySelectorAll(`input[type="checkbox"]`).length > 0
				&& labelWrapper.querySelectorAll(`input[type="checkbox"]`).length !== 1)
				|| labelWrapper.querySelectorAll(`input[type="radio"]`).length > 0
			) {
				label.setAttribute("id", uuidv4());
				groupWrapper.setAttribute("role", "group");
				groupWrapper.setAttribute("aria-labelledby", label.getAttribute("id"));
			}
		});
	};
};

export const addARIARolesForTabs = form => {
	if (form && form.getElementsByClassName("flw__tabs__tabs-list")[0]) {
		const formContainerElement = form.getElementsByClassName("flw__tabs__tabs-list")[0];

		formContainerElement.setAttribute("role", "tablist");
		formContainerElement.setAttribute("aria-label", "Preview form sections");

		const activeTabItemSelector = ".flw__tabs__tab-item--active__button";
		const tabItemSelector = ".flw__tabs__tab-item__button";
		const selectedTab = formContainerElement.querySelector(activeTabItemSelector);

		if (selectedTab) {
			formContainerElement.querySelectorAll(tabItemSelector).forEach(tab => {
				tab.setAttribute("aria-label", tab.textContent);
				tab.setAttribute("role", "tab");
				tab.setAttribute("aria-controls", tab.getAttribute("name"));
				tab.setAttribute("aria-selected", "false");

				tab.addEventListener("click", event => {
					formContainerElement.querySelectorAll(tabItemSelector).forEach(tab => {
						tab.setAttribute("aria-selected", "false");
					});

					event.target.setAttribute("aria-selected", "true");
				});
			});
			selectedTab.setAttribute("aria-selected", "true");
		}
	}
}

export const restoreFocusToDatePickerOnChange = form => {
	const datePickers = form.querySelectorAll(".react-datepicker__input-container input");

	datePickers.forEach(input => {
		if (input) {
			const observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					if (mutation.attributeName === "value") {
						setTimeout(() => {
							input.focus();
							observer.disconnect();
						}, 0);
					}
				});
			});

			input.addEventListener("focus", () => {
				observer.observe(input, { 
					attributes: true, 
					attributeFilter: ['value'] 
				});
			});
		}
	});
} 

export const useFormImproveA11y = (isFormReady, formContainerRef) => {
	const [ updated, forceUpdate ] = useReducer(prev => prev + 1, 0);

	useLayoutEffect(() => {
		if (!isFormReady || !formContainerRef?.current) return;

		const sectionsContainer = formContainerRef?.current?.getElementsByClassName("flw__tabs__tabs-list")[0];

		if(sectionsContainer) {
			// trigger force update to find and assign attributes to elements
			sectionsContainer.addEventListener("click", forceUpdate);

			return () => {
				sectionsContainer.removeEventListener("click", forceUpdate);
			};
		}
	}, [ isFormReady ]);

	const applyDOMMutations = () => {
		// need to use timeout because of async rendering after change section
		setTimeout(() => {
			if (isFormReady && Helper?.formRef) {
				const formSection = formContainerRef?.current?.querySelector(".formSection");

				addARIAGroupingAttributes(formSection);
				addARIARolesForTabs(formSection);
				restoreFocusToDatePickerOnChange(formSection);
			}
		}, 50);
	};

	useEffect(() => {
		// Do on initial form load
		applyDOMMutations();
	}, [ isFormReady ]);

	useEffect(() => {
		if (!isFormReady || !formContainerRef?.current) return;

		// Do after change section
		applyDOMMutations();
	}, [ updated ]);
};
